import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(15, 17, 26, 0.55)',
    backdropFilter: 'blur(4px)',
    zIndex: 99999,
    display: 'flex',
    alignItems: 'stretch',
    animation: '$fadeIn 0.3s ease-out',
  },
  overlayClosing: {
    animation: '$fadeOut 0.3s ease-in forwards',
  },
  modal: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#f4f5f7',
    transform: 'translateY(0)',
    animation: '$slideUp 0.3s ease-out',
  },
  modalClosing: {
    animation: '$slideDown 0.3s ease-in forwards',
  },
  rightPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 2rem',
    background: '#001a40',
    flexShrink: 0,
  },

  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },

  headerTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    color: '#fff',
    lineHeight: 1.3,
  },
  headerSubtitle: {
    fontSize: '0.8rem',
    color: 'rgba(255,255,255,0.55)',
    marginTop: '0.1rem',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },

  closeButton: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2rem',
    height: '2rem',
    color: 'rgba(255,255,255,0.7)',
    transition: 'all 0.15s',
    '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)', color: '#fff' },
  },

  content: {
    flex: 1,
    overflowY: 'auto',
    padding: '2rem',
  },
  globalConfigWrapper: {
    maxWidth: '700px',
    padding: '24px',
    position: 'relative',
  },
  saveOverlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 100000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  alertBanner: {
    width: 'fit-content',
    marginLeft: 'auto',
    marginTop: '8px',
  },
  contentHeader: {
    marginBottom: '1.5rem',
    paddingBottom: '1rem',
    borderBottom: '1px solid #e5e7eb',
  },
  contentTitle: {
    fontWeight: 700,
    fontSize: '1.0625rem',
    color: '#111827',
  },
  contentSubtitle: {
    fontSize: '0.8125rem',
    color: '#6b7280',
    marginTop: '0.25rem',
  },

  headerSourceCircle: {
    width: '2.5rem',
    height: '2.5rem',
    borderRadius: '50%',
    backgroundColor: '#f3f4f6',
    border: '1.5px solid #e5e7eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    overflow: 'hidden',
  },
  headerSourceImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '50%',
  },

  tabsBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '0.75rem 2rem',
    backgroundColor: '#fff',
    borderBottom: '1px solid #e5e7eb',
  },
  tab: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '10px 20px',
    cursor: 'pointer',
    border: 'none',
    borderBottom: '3px solid transparent',
    background: 'transparent',
    fontSize: '14px',
    fontWeight: 600,
    color: '#1a1a1a',
    opacity: 0.7,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    marginRight: '12px',
    '&:hover': {
      borderBottom: '3px solid #cbd5e1',
    },
  },
  tabIcon: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  tabActive: {
    color: '#254B86',
    borderBottom: '3px solid rgba(55,81,255,1)',
    opacity: 1,
    '&:hover': {
      borderBottom: '3px solid rgba(55,81,255,1)',
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0.875rem 2rem',
    backgroundColor: '#fff',
    borderTop: '1px solid #e5e7eb',
    boxShadow: '0 -1px 4px rgba(0,0,0,0.04)',
  },
  configSectionDivider: {
    border: 'none',
    borderTop: '1px solid #e5e7eb',
    margin: '2rem 0',
  },
  configSectionTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    color: '#111827',
    marginBottom: '0.25rem',
  },
  configSectionDesc: {
    fontSize: '0.8125rem',
    color: '#6b7280',
    marginBottom: '1.5rem',
  },
  configRows: {
    border: '1px solid #e5e7eb',
    borderRadius: '10px',
    overflow: 'hidden',
    backgroundColor: '#fff',
  },
  configRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
    padding: '1rem 1.25rem',
    borderBottom: '1px solid #f3f4f6',
    '&:last-child': { borderBottom: 'none' },
  },
  configRowLabel: {
    flex: '0 0 200px',
  },
  configRowHint: {
    fontSize: '0.75rem',
    color: '#9ca3af',
    marginTop: '0.125rem',
  },
  configRowInput: {
    flex: 1,
    maxWidth: '280px',
  },
  simulationUploadSection: {
    padding: '1.25rem 1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  configBoxFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '1.25rem',
  },
  field: {
    marginBottom: '1.5rem',
  },
  menuInputWrapper: {
    maxWidth: '420px',
  },
  globalConfigFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    maxWidth: '420px',
    marginTop: '0.5rem',
  },
  label: {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: 500,
    fontSize: '0.8125rem',
    color: '#374151',
  },
  select: {
    width: '100%',
    maxWidth: '420px',
    padding: '0.625rem 1rem',
    border: '1.5px solid #e5e7eb',
    borderRadius: '10px',
    fontSize: '0.9375rem',
    color: '#1a1d29',
    backgroundColor: '#fff',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '56px 40px',
    borderRadius: '16px',
    minHeight: '340px',
    gap: '16px',
  },
  errorIconWrap: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    background: 'rgba(220, 38, 38, 0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 0 0 8px rgba(220, 38, 38, 0.08), 0 0 24px rgba(220, 38, 38, 0.3)',
    marginBottom: '4px',
    animation: '$errorPulse 2s ease-in-out infinite',
  },
  '@keyframes errorPulse': {
    '0%, 100%': {
      boxShadow: '0 0 0 0 rgba(220, 38, 38, 0.4), 0 0 0 0 rgba(220, 38, 38, 0.2)',
      transform: 'scale(1)',
    },
    '50%': {
      boxShadow: '0 0 0 12px rgba(220, 38, 38, 0), 0 0 0 24px rgba(220, 38, 38, 0)',
      transform: 'scale(1.08)',
    },
  },
  errorText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
  },
  errorTitle: {
    color: '#111827',
    fontWeight: 700,
    fontSize: '1.0625rem',
    textAlign: 'center',
  },
  errorMessage: {
    color: '#6b7280',
    fontSize: '0.875rem',
    textAlign: 'center',
    maxWidth: '340px',
    lineHeight: 1.6,
  },
  '@keyframes pulse': {
    '0%, 100%': { boxShadow: '0 0 0 0 rgba(220, 38, 38, 0.15)' },
    '50%': { boxShadow: '0 0 0 8px rgba(220, 38, 38, 0)' },
  },
  '@keyframes slideUp': {
    from: { transform: 'translateY(100%)' },
    to: { transform: 'translateY(0)' },
  },
  '@keyframes slideDown': {
    from: { transform: 'translateY(0)' },
    to: { transform: 'translateY(100%)' },
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  '@keyframes fadeOut': {
    from: { opacity: 1 },
    to: { opacity: 0 },
  },
});

export default useStyles;
